/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import {
  IndexRoute,
  Route,
} from 'react-router';
import Gateway from '../Gateway';
import GatewayAdd from '../Gateway/coms/GatewayAdd';
import GatewayDetail from '../Gateway/coms/GatewayDetail';
import DetailView from '../Gateway/coms/GatewayDetail/coms/DetailView';
import StatView from '../Gateway/coms/GatewayDetail/coms/StatView';
import DataMsgView from '../Gateway/coms/GatewayDetail/coms/DataMsgView';
import LogView from '../Gateway/coms/GatewayDetail/coms/LogView';
import ConfView from '../Gateway/coms/GatewayDetail/coms/ConfView';

const GatewayRoutes = (
  <Route path="gateway">
    <IndexRoute component={Gateway} />
    <Route path="add" component={GatewayAdd} />
    <Route path="detail/:id" component={GatewayDetail}>
      <IndexRoute component={DetailView} />
      <Route path="stat" component={StatView} />
      <Route path="datamsg" component={DataMsgView} />
      <Route path="log" component={LogView} />
      <Route path="conf" component={ConfView} />
    </Route>
  </Route>
);

export default GatewayRoutes;




// WEBPACK FOOTER //
// ./src/containers/Routes/GatewayRoutes.jsx